import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, TibboDataType,
} from '@appblocks/codegeneration/types';
import * as simulator from './simulator';
import * as tios from './tios';

export default class Tibbit_36 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_36';
        this.name = 'Tibbit 36';

        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];

        const settings = [
            {
                id: 'X_AXIS_NAME',
                name: 'X-axis Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.INTEGER,
                default: '',
                required: true,
            },
            {
                id: 'Y_AXIS_NAME',
                name: 'Y-axis Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.INTEGER,
                default: '',
                required: true,
            },
            {
                id: 'Z_AXIS_NAME',
                name: 'Z-axis Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.INTEGER,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);

        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt36/tbt36.tbh',
            'libraries/tibbits/tbt36/tbt36.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
    }

    getCodeBlocks(): Array<CodeBlock> {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }
}
